module.exports = __webpack_public_path__ + "static/media/animation.28d53192.png";